import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Heart, User, X } from "lucide-react";
import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { brand, mainNav } from "@/config/brand";

export function MobileNav({ open, onOpenChange, isAuthenticated, wishCount }) {
  const close = () => onOpenChange(false);
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[85%] max-w-sm border-r border-border bg-ivory p-0 [&>button]:hidden" data-testid="mobile-nav">
        <SheetTitle className="sr-only">Navigation menu</SheetTitle>
        <SheetDescription className="sr-only">Browse {brand.name}</SheetDescription>
        <div className="flex items-center justify-between border-b border-border px-5 py-5">
          <span className="font-serif text-xl tracking-[0.18em] text-ink">{brand.name}</span>
          <button onClick={close} aria-label="Close menu" data-testid="mobile-nav-close" className="text-ink hover:text-gold">
            <X size={20} />
          </button>
        </div>
        <nav className="flex flex-col px-5 py-4">
          {mainNav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              onClick={close}
              className={({ isActive }) => `border-b border-border/60 py-3.5 font-serif text-lg ${isActive ? "text-gold" : "text-ink"}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex flex-col gap-1 px-5 pt-2">
          <Link to={isAuthenticated ? "/account" : "/login"} onClick={close} className="flex items-center gap-3 py-2 text-sm uppercase tracking-wider text-ink hover:text-gold">
            <User size={17} /> Account
          </Link>
          <Link to="/wishlist" onClick={close} className="flex items-center gap-3 py-2 text-sm uppercase tracking-wider text-ink hover:text-gold">
            <Heart size={17} /> Wishlist {wishCount > 0 && `(${wishCount})`}
          </Link>
        </div>
      </SheetContent>
    </Sheet>
  );
}
